export function getLocalData(key) {
  const data = sessionStorage.getItem(`lnd_actionCardData_${key}`)
  return data ? JSON.parse(data) : null
}

export function saveLocalData(data, key) {
  sessionStorage.setItem(`lnd_actionCardData_${key}`, JSON.stringify(data))
}

export function clearLocalData(key) {
  sessionStorage.removeItem(`lnd_actionCardData_${key}`)
}
